module.exports = "/_next/static/images/down-monotone-509bdb20bda7f3514cbd5a8ca4594a60.svg";